import request from '@/utils/http';
import store from '@/store/index';
import { PFX } from '../../constant/constant.js';
const tenantCode = store.getters.currentTenant.tenantCode;

const costName = {
// 获取列表
    get(params) {
        params.tenantCode = tenantCode;
        return request({
            url: `${PFX}/contract/contractInfos/forSupplier`,
            method: 'post',
            data: params
        });
    },
    getFiles (params) {
        params.tenantCode = tenantCode;
        return request({
            url: `${PFX}/contract/contractFiles`,
            method: 'post',
            data: params
        });
    },
    // 签署接口
    getAuthorizationUrl (params) {
        return request({
            url: `/api-srm-web/supplier/getAuthorizationUrl`,
            method: 'get'
        });
    }
};
export default costName;
